import Section from 'components/Section'
import { buildTranslate } from 'locales'
import React from 'react'
import { useSelector } from 'react-redux'
import { getExtension } from 'scenes/Cms/helper'
import { selectApp } from 'selectors/app'
import Header from '../../components/Header'
import Asset from '../Asset'
import ImageAsset from '../ImageAsset'

const t = buildTranslate('cms.brand.app_store_assets')

const AppStoreSearchResult = () => {
  const app = useSelector(selectApp)

  if (!app) return null

  const { ios_search_result_image_urls: image } = app

  return (
    <Section className="p-xl mt-l">
      <Header title={t('app_store_search_result.title')} />
      <Asset
        className="mt-s"
        description={t('app_store_search_result.description')}
        badges={[t('app_store_search_result.size'), getExtension(image?.small)]}
      >
        <ImageAsset width="180px" height="120px" image={image?.small} />
      </Asset>
    </Section>
  )
}

export default AppStoreSearchResult
